import * as React from "react";
function SvgBubbleGraph(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        d="M29 23h-4v6l-6-6H3a2 2 0 01-2-2V5a2 2 0 012-2h26a2 2 0 012 2v16a2 2 0 01-2 2z"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
      />
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
        d="M23.73 10.17L17 17l-5-5-5 5"
      />
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
        d="M24.94 14.85V9H19.1"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgBubbleGraph);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
